module.exports = __webpack_public_path__ + "img/ring_r_skip_null_null@2x.558bda71.png";